export default __webpack_public_path__ + "appointments/static/media/brown.32061156.png";